import { useCallback, useMemo, useRef, useState } from 'react';
export const useDriverSettings = () => {
    /** Driver から情報を受け取る用の Ref */
    const driverRef = useRef(null);
    /** Driver から情報を受け取る用の State */
    const [driverState, changeDriverState] = useState(null);
    /** Driver の対象がアクティブかどうか */
    const getIsActiveDriverTarget = useCallback((targetIndex) => (driverState === null || driverState === void 0 ? void 0 : driverState.isShow) && (driverState === null || driverState === void 0 ? void 0 : driverState.activeIndex) === targetIndex, [driverState]);
    /**
     * Driver 表示状態
     */
    const isShow = useMemo(() => !!(driverState === null || driverState === void 0 ? void 0 : driverState.isShow), [driverState]);
    /**
     * Driver の表示
     */
    const showDriver = useCallback(() => {
        var _a, _b;
        (_b = (_a = driverRef.current) === null || _a === void 0 ? void 0 : _a.start) === null || _b === void 0 ? void 0 : _b.call(_a);
    }, [driverRef]);
    /**
     * Driver の表示終了
     */
    const stopDriver = useCallback(() => {
        var _a, _b;
        (_b = (_a = driverRef.current) === null || _a === void 0 ? void 0 : _a.stop) === null || _b === void 0 ? void 0 : _b.call(_a);
    }, [driverRef]);
    /**
     * Driver 初期化
     */
    const resetDriver = useCallback(() => {
        var _a, _b;
        (_b = (_a = driverRef.current) === null || _a === void 0 ? void 0 : _a.reset) === null || _b === void 0 ? void 0 : _b.call(_a);
    }, [driverRef]);
    /**
     * 次の項目に移動
     */
    const changeDriverTarget = useCallback(() => {
        var _a, _b;
        (_b = (_a = driverRef.current) === null || _a === void 0 ? void 0 : _a.onChangeTarget) === null || _b === void 0 ? void 0 : _b.call(_a);
    }, [driverRef]);
    /**
     * ハイライト要素 クリック時のイベント（次要素移動）
     */
    const onClickDriverTarget = useCallback((e) => {
        var _a, _b;
        e.preventDefault();
        (_b = (_a = driverRef.current) === null || _a === void 0 ? void 0 : _a.onChangeTarget) === null || _b === void 0 ? void 0 : _b.call(_a);
    }, [driverRef]);
    return {
        changeDriverState,
        changeDriverTarget,
        driverRef,
        getIsActiveDriverTarget,
        isShowDriver: isShow,
        onClickDriverTarget,
        resetDriver,
        showDriver,
        stopDriver,
    };
};
